import { Row } from '@components/LinearLayout';
import { styled } from 'styled-components';

export const ModalRoot = styled.div<{
  $mounted: boolean;
  $shouldScroll?: boolean;
  $scrollBarColor?: string;
}>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(76, 86, 103, 0.3);
  z-index: 10002;
  transition: opacity 0.25s ease-in-out;
  cursor: pointer;
  overflow: hidden;
  padding: 5rem 2rem;
  backdrop-filter: blur(0.15rem);
  display: ${props => (props.$mounted ? 'flex' : 'none')};
  overflow-x: hidden;
  justify-content: center;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding: 0;
  }

  ::-webkit-scrollbar {
    width: 1rem;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar-track:hover {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ $scrollBarColor }) => $scrollBarColor};
    border-radius: ${({ theme }) => theme.borderRadius.radius10};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${({ $scrollBarColor }) => $scrollBarColor};
    border-radius: ${({ theme }) => theme.borderRadius.radius10};
  }
  scrollbar-width: thin;
  scrollbar-color: ${({ $scrollBarColor }) => $scrollBarColor}
    ${({ $scrollBarColor }) => $scrollBarColor};
`;

ModalRoot.defaultProps = { $mounted: false };

export const ModalContainer = styled.div<{
  $width?: string;
  $maxHeight?: string;
  $backgroundColor?: string;
  $activateAnimation?: boolean;
  $animation?: boolean;
  $height?: string;
  $contentPadding?: string;
  $overflow?: string;
}>`
  background-color: ${props =>
    props.$backgroundColor ? props.$backgroundColor : props.theme.color.white};
  max-height: ${({ $maxHeight }) => $maxHeight};
  width: ${({ $width }) => $width};
  border-radius: ${({ theme }) => theme.borderRadius.radius20};
  cursor: auto;
  position: relative;
  top: 0rem;
  padding: 1.5rem;
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: fit-content;
  border: 0.5rem solid ${({ theme }) => theme.color.lightGrey};
  overflow: ${({ $overflow }) => $overflow || 'scroll'};

  ${({ $contentPadding }) =>
    $contentPadding ? `padding:  ${$contentPadding};` : `padding:  1.5rem;`};

  ${({ $animation }) => $animation && `transition: right 600ms ease-in-out;`};
  right: ${({ $activateAnimation, $animation }) => {
    if ($animation && !$activateAnimation) return '-100%';
    else return '0';
  }};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    top: 10rem;
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    top: 5rem;
    ${({ $height }) =>
      $height && `height: ${$height}; top: 0; max-height: ${$height};`};
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    width: 100%;
    border-top-left-radius: ${({ theme }) => theme.borderRadius.radius10};
    border-top-right-radius: ${({ theme }) => theme.borderRadius.radius10};
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-left: 0;
    border-right: 0;
    position: fixed;
    top: 5rem;
    border: 0;
    ${({ $height }) => $height && `height: ${$height}; top: 0;`};
  }
`;
ModalContainer.defaultProps = { $width: '43.5rem' };

export const CloseIcon = styled.div`
  display: flex;
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  cursor: pointer;
  z-index: 99999;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    top: 2rem;
    right: 0;
    left: 90vw;

    i {
      background-color: white;
      border-radius: 50%;
    }
  }
`;

export const Title = styled(Row)`
  justify-content: center;
`;
